import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";

export const getMobileDrillDownData: { [key in ModuleConfig]?: ModuleFields[] } = {
  header: [
    {
      fieldName: "Header Image",
      fieldValue: "image",
      className: "col-span-6",
      type: "image",
      name: "image",
      formType: "file",
      label: "Header Image",
      placeholder: "Upload header image",
      usedFileType: "image/*",
      validation: { required: "Header image is required" },
    },
    {
      fieldName: "Welcome Text",
      fieldValue: "welcomeText",
      className: "col-span-6",
      type: "text",
      name: "welcomeText",
      formType: "input",
      label: "Welcome Text",
      placeholder: "Enter welcome text",
      validation: { required: "Welcome text is required" },
    },
    {
      fieldName: "Sub Text",
      fieldValue: "subText",
      className: "col-span-6",
      type: "text",
      name: "subText",
      formType: "input",
      label: "Sub Text",
      placeholder: "Enter sub text",
      validation: { required: "Sub text is required" },
    },
    {
      fieldName: "Android QR Image",
      fieldValue: "androidQrImage",
      className: "col-span-6",
      type: "image",
      name: "androidQrImage",
      formType: "file",
      label: "Android QR Image",
      placeholder: "Upload Android QR image",
      usedFileType: "image/*",
      validation: { required: "Android QR image is required" },
    },
    {
      fieldName: "iOS QR Image",
      fieldValue: "iosQrImage",
      className: "col-span-6",
      type: "image",
      name: "iosQrImage",
      formType: "file",
      label: "iOS QR Image",
      placeholder: "Upload iOS QR image",
      usedFileType: "image/*",
      validation: { required: "iOS QR image is required" },
    },
    {
      fieldName: "Android Text",
      fieldValue: "androidText",
      className: "col-span-6",
      type: "text",
      name: "androidText",
      formType: "input",
      label: "Android Text",
      placeholder: "Enter Android text",
      validation: { required: "Android text is required" },
    },
    {
      fieldName: "iOS Text",
      fieldValue: "iosText",
      className: "col-span-6",
      type: "text",
      name: "iosText",
      formType: "input",
      label: "iOS Text",
      placeholder: "Enter iOS text",
      validation: { required: "iOS text is required" },
    },
    {
      fieldName: "Android Link",
      fieldValue: "androidLink",
      className: "col-span-6",
      type: "text",
      name: "androidLink",
      formType: "input",
      label: "Android Link",
      placeholder: "Enter Android app link",
      validation: { required: "Android link is required" },
    },
    {
      fieldName: "iOS Link",
      fieldValue: "iosLink",
      className: "col-span-6",
      type: "text",
      name: "iosLink",
      formType: "input",
      label: "iOS Link",
      placeholder: "Enter iOS app link",
      // validation: { required: "iOS link is required" },
    },
    {
      fieldName: "Scan Description (EN)",
      fieldValue: "scan_description_en",
      className: "col-span-12",
      type: "text",
      name: "scan_description_en",
      formType: "richText",
      label: "Scan Description (English)",
      placeholder: "Enter scan description content",
      validation: { required: "Scan description is required" },
    },
    {
      fieldName: "Meta Title (EN)",
      fieldValue: "meta_title_en",
      className: "col-span-12",
      type: "text",
      name: "meta_title_en",
      formType: "input",
      label: "Meta Title (English)",
      placeholder: "Enter meta title",
      validation: { required: "Meta title is required" },
    },
    {
      fieldName: "Meta Description (EN)",
      fieldValue: "meta_desc_en",
      className: "col-span-12",
      type: "textarea",
      name: "meta_desc_en",
      formType: "textarea",
      label: "Meta Description (English)",
      placeholder: "Enter meta description",
      validation: { required: "Meta description is required" },
    },
    {
      fieldName: "Metadata Image",
      fieldValue: "metadataImage",
      className: "col-span-6",
      type: "image",
      name: "metadataImage",
      formType: "file",
      label: "Metadata Image",
      placeholder: "Upload metadata image",
      usedFileType: "image/*",
      validation: { required: "Metadata image is required" },
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Select if header is published",
    },
  ],

  spotlightSectionOne: [
    {
      fieldName: "Banner Image",
      fieldValue: "banner",
      className: "col-span-6",
      type: "image",
      name: "banner",
      formType: "file",
      label: "Banner Image",
      usedFileType: "image/*",
      placeholder: "Upload banner image",
      validation: { required: "Banner Image is required" },
    },
    {
      fieldName: "Title",
      fieldValue: "title",
      className: "col-span-6",
      type: "text",
      name: "title",
      formType: "input",
      label: "Title",
      placeholder: "Enter Title",
      validation: { required: "Title is required" },
    },
    {
      fieldName: "Airports",
      fieldValue: "airports",
      className: "col-span-12",
      type: "select",
      name: "airports",
      formType: "select",
      label: "Airports",
      placeholder: "Select Airports",
      options: [
        { label: "KLIA1", value: "klia1" },
        { label: "KLIA II", value: "kliaII" },
        { label: "Penang", value: "penang" },
      ],
      validation: { required: "At least one airport is required" },
    },
    {
      fieldName: "Body",
      fieldValue: "body",
      className: "col-span-12",
      type: "text",
      name: "body",
      formType: "textarea",
      label: "Body",
      placeholder: "Enter Body Content",
      validation: { required: "Body content is required" },
    },
    {
      fieldName: "Redirected URL",
      fieldValue: "link",
      className: "col-span-6",
      type: "text",
      name: "link",
      formType: "input",
      label: "Redirected URL",
      placeholder: "Enter redirected URL (e.g., https://...)",
      validation: { required: "Redirected URL is required" },
    },
    {
      fieldName: "Sequence",
      fieldValue: "sequence",
      className: "col-span-6",
      type: "number",
      name: "sequence",
      formType: "input",
      label: "Sequence",
      placeholder: "Enter sequence (e.g., 1)",
      validation: { required: "Sequence is required" },
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "",
    },
  ],

  appAbout: [
    // {
    //   fieldName: "About Text (EN)",
    //   fieldValue: "about_text_english",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "about_text_english",
    //   formType: "input",
    //   label: "About Text (EN)",
    //   placeholder: "Enter About text (EN)",
    //   validation: { required: "About text (EN) is required" },
    // },
    // {
    //   fieldName: "About Text (MS)",
    //   fieldValue: "about_text_malay",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "about_text_malay",
    //   formType: "input",
    //   label: "About Text (MS)",
    //   placeholder: "Enter About text (MS)",
    // },
    // {
    //   fieldName: "About Text (ZH)",
    //   fieldValue: "about_text_mandarin",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "about_text_mandarin",
    //   formType: "input",
    //   label: "About Text (ZH)",
    //   placeholder: "Enter About text (ZH)",
    // },
    // {
    //   fieldName: "About Description (EN)",
    //   fieldValue: "about_description_english",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "about_description_english",
    //   formType: "textarea",
    //   label: "About Description (EN)",
    //   placeholder: "Enter About Description (EN)",
    //   validation: { required: "About Description (EN) is required" },
    // },
    // {
    //   fieldName: "About Description (MS)",
    //   fieldValue: "about_description_malay",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "about_description_malay",
    //   formType: "textarea",
    //   label: "About Description (MS)",
    //   placeholder: "Enter About Description (MS)",
    // },
    // {
    //   fieldName: "About Description (ZH)",
    //   fieldValue: "about_description_mandarin",
    //   className: "col-span-6",
    //   type: "text",
    //   name: "about_description_mandarin",
    //   formType: "textarea",
    //   label: "About Description (ZH)",
    //   placeholder: "Enter About Description (ZH)",
    // },
    // {
    //   fieldName: "About Image",
    //   fieldValue: "aboutImage",
    //   className: "col-span-6",
    //   type: "image",
    //   name: "aboutImage",
    //   formType: "file",
    //   label: "About Image",
    //   placeholder: "Upload about image",
    //   usedFileType: "image/*",
    //   validation: { required: "About image is required" },
    // },
    {
      fieldName: "Mobile App Description (EN)",
      fieldValue: "mobile_app_desc_english",
      className: "col-span-6",
      type: "text",
      name: "mobile_app_desc_english",
      formType: "textarea",
      label: "Mobile App Description (EN)",
      placeholder: "Enter Mobile App description (EN)",
      validation: { required: "Mobile App description (EN) is required" },
    },
    {
      fieldName: "Mobile App Description (MS)",
      fieldValue: "mobile_app_desc_malay",
      className: "col-span-6",
      type: "text",
      name: "mobile_app_desc_malay",
      formType: "textarea",
      label: "Mobile App Description (MS)",
      placeholder: "Enter Mobile App description (MS)",
    },
    {
      fieldName: "Mobile App Description (ZH)",
      fieldValue: "mobile_app_desc_mandarin",
      className: "col-span-6",
      type: "text",
      name: "mobile_app_desc_mandarin",
      formType: "textarea",
      label: "Mobile App Description (ZH)",
      placeholder: "Enter Mobile App description (ZH)",
    },
    {
      fieldName: "Android QR Image",
      fieldValue: "androidQrImage",
      className: "col-span-6",
      type: "image",
      name: "androidQrImage",
      formType: "file",
      usedFileType: "image/*",
      label: "Android QR Image",
      placeholder: "Upload Android QR Image",
      // validation: { required: "Android QR Image is required" },
    },
    {
      fieldName: "Android Text (EN)",
      fieldValue: "android_text_english",
      className: "col-span-6",
      type: "text",
      name: "android_text_english",
      formType: "input",
      label: "Android Text (EN)",
      placeholder: "Enter Android Text (EN)",
      // validation: { required: "Android Text (EN) is required" },
    },
    {
      fieldName: "Android Text (MS)",
      fieldValue: "android_text_malay",
      className: "col-span-6",
      type: "text",
      name: "android_text_malay",
      formType: "input",
      label: "Android Text (MS)",
      placeholder: "Enter Android Text (MS)",
      // validation: { required: "Android Text (MS) is required" },
    },
    {
      fieldName: "Android Text (ZH)",
      fieldValue: "android_text_mandarin",
      className: "col-span-6",
      type: "text",
      name: "android_text_mandarin",
      formType: "input",
      label: "Android Text (ZH)",
      placeholder: "Enter Android Text (ZH)",
      // validation: { required: "Android Text (ZH) is required" },
    },
    {
      fieldName: "Android Link",
      fieldValue: "androidLink",
      className: "col-span-6",
      type: "text",
      name: "androidLink",
      formType: "input",
      label: "Android Link",
      placeholder: "Enter Android App Link",
      // validation: { required: "Android App Link is required" },
    },
    {
      fieldName: "IOS QR Image",
      fieldValue: "iosQrImage",
      className: "col-span-6",
      type: "image",
      name: "iosQrImage",
      formType: "file",
      usedFileType: "image/*",
      label: "IOS QR Image",
      placeholder: "Upload IOS QR Image",
      // validation: { required: "IOS QR Image is required" },
    },
    {
      fieldName: "IOS Text (EN)",
      fieldValue: "ios_text_english",
      className: "col-span-6",
      type: "text",
      name: "ios_text_english",
      formType: "input",
      label: "IOS Text (EN)",
      placeholder: "Enter IOS Text (EN)",
      // validation: { required: "IOS Text (EN) is required" },
    },
    {
      fieldName: "IOS Text (MS)",
      fieldValue: "ios_text_malay",
      className: "col-span-6",
      type: "text",
      name: "ios_text_malay",
      formType: "input",
      label: "IOS Text (MS)",
      placeholder: "Enter IOS Text (MS)",
      // validation: { required: "Android Text (MS) is required" },
    },
    {
      fieldName: "IOS Text (ZH)",
      fieldValue: "ios_text_mandarin",
      className: "col-span-6",
      type: "text",
      name: "ios_text_mandarin",
      formType: "input",
      label: "IOS Text (ZH)",
      placeholder: "Enter IOS Text (ZH)",
      // validation: { required: "Android Text (ZH) is required" },
    },
    {
      fieldName: "IOS Link",
      fieldValue: "iosLink",
      className: "col-span-6",
      type: "text",
      name: "iosLink",
      formType: "input",
      label: "IOS Link",
      placeholder: "Enter IOS App Link",
      // validation: { required: "IOS App Link is required" },
    },
    {
      fieldName: "Bottom Image",
      fieldValue: "bottomImage",
      className: "col-span-6",
      type: "image",
      name: "bottomImage",
      formType: "file",
      label: "Bottom Image",
      placeholder: "Upload bottom image",
      usedFileType: "image/*",
      validation: { required: "Bottom image is required" },
    },
  ],
  appHeader: [
    {
      fieldName: "Image",
      fieldValue: "Image",
      className: "col-span-6",
      type: "image",
      name: "Image",
      formType: "file",
      usedFileType: "image/*",
      label: "Image",
      placeholder: "Upload Image",
      validation: { required: "Image is required" },
    },
    {
      fieldName: "Welcome Text (EN)",
      fieldValue: "welcomeText",
      className: "col-span-6",
      type: "text",
      name: "welcomeText",
      formType: "input",
      label: "Welcome Text (EN)",
      placeholder: "Enter Welcome Text (EN)",
      validation: { required: "Welcome Text (EN) is required" },
    },
    {
      fieldName: "Welcome Text (MS)",
      fieldValue: "welcome_text_ms",
      className: "col-span-6",
      type: "text",
      name: "welcome_text_ms",
      formType: "input",
      label: "Welcome Text (MS)",
      placeholder: "Enter Welcome Text (MS)",
      // validation: { required: "Welcome Text (EN) is required" },
    },
    {
      fieldName: "Welcome Text (ZH)",
      fieldValue: "welcome_text_zh",
      className: "col-span-6",
      type: "text",
      name: "welcome_text_zh",
      formType: "input",
      label: "Welcome Text (ZH)",
      placeholder: "Enter Welcome Text (ZH)",
      // validation: { required: "Welcome Text (ZH) is required" },
    },
    {
      fieldName: "Sub Text (EN)",
      fieldValue: "subText",
      className: "col-span-6",
      type: "text",
      name: "subText",
      formType: "input",
      label: "Sub Text (EN)",
      placeholder: "Enter Sub Text (EN)",
      validation: { required: "Sub Text (EN) is required" },
    },
    {
      fieldName: "Sub Text (MS)",
      fieldValue: "sub_text_ms",
      className: "col-span-6",
      type: "text",
      name: "sub_text_ms",
      formType: "input",
      label: "Sub Text (MS)",
      placeholder: "Enter Sub Text (MS)",
      // validation: { required: "Sub Text (EN) is required" },
    },
    {
      fieldName: "Sub Text (ZH)",
      fieldValue: "sub_text_zh",
      className: "col-span-6",
      type: "text",
      name: "sub_text_zh",
      formType: "input",
      label: "Sub Text (ZH)",
      placeholder: "Enter Sub Text (ZH)",
      // validation: { required: "Sub Text (EN) is required" },
    },
    {
      fieldName: "Android QR Image",
      fieldValue: "androidQrImage",
      className: "col-span-6",
      type: "image",
      name: "androidQrImage",
      formType: "file",
      usedFileType: "image/*",
      label: "Android QR Image",
      placeholder: "Upload Android QR Image",
      // validation: { required: "Android QR Image is required" },
    },
    {
      fieldName: "Android Text (EN)",
      fieldValue: "androidText",
      className: "col-span-6",
      type: "text",
      name: "androidText",
      formType: "input",
      label: "Android Text (EN)",
      placeholder: "Enter Android Text (EN)",
      // validation: { required: "Android Text (EN) is required" },
    },
    {
      fieldName: "Android Text (MS)",
      fieldValue: "androidTextMs",
      className: "col-span-6",
      type: "text",
      name: "androidTextMs",
      formType: "input",
      label: "Android Text (MS)",
      placeholder: "Enter Android Text (MS)",
      // validation: { required: "Android Text (MS) is required" },
    },
    {
      fieldName: "Android Text (ZH)",
      fieldValue: "androidTextZh",
      className: "col-span-6",
      type: "text",
      name: "androidTextZh",
      formType: "input",
      label: "Android Text (ZH)",
      placeholder: "Enter Android Text (ZH)",
      // validation: { required: "Android Text (ZH) is required" },
    },
    {
      fieldName: "Android Link",
      fieldValue: "androidLink",
      className: "col-span-6",
      type: "text",
      name: "androidLink",
      formType: "input",
      label: "Android Link",
      placeholder: "Enter Android App Link",
      // validation: { required: "Android App Link is required" },
    },
    {
      fieldName: "IOS QR Image",
      fieldValue: "iosQrImage",
      className: "col-span-6",
      type: "image",
      name: "iosQrImage",
      formType: "file",
      usedFileType: "image/*",
      label: "IOS QR Image",
      placeholder: "Upload IOS QR Image",
      // validation: { required: "IOS QR Image is required" },
    },
    {
      fieldName: "IOS Text (EN)",
      fieldValue: "iosText",
      className: "col-span-6",
      type: "text",
      name: "iosText",
      formType: "input",
      label: "IOS Text (EN)",
      placeholder: "Enter IOS Text (EN)",
      // validation: { required: "IOS Text (EN) is required" },
    },
    {
      fieldName: "IOS Text (MS)",
      fieldValue: "iosTextMs",
      className: "col-span-6",
      type: "text",
      name: "iosTextMs",
      formType: "input",
      label: "IOS Text (MS)",
      placeholder: "Enter IOS Text (MS)",
      // validation: { required: "Android Text (MS) is required" },
    },
    {
      fieldName: "IOS Text (ZH)",
      fieldValue: "iosTextZh",
      className: "col-span-6",
      type: "text",
      name: "iosTextZh",
      formType: "input",
      label: "IOS Text (ZH)",
      placeholder: "Enter IOS Text (ZH)",
      // validation: { required: "Android Text (ZH) is required" },
    },
    {
      fieldName: "IOS Link",
      fieldValue: "iosLink",
      className: "col-span-6",
      type: "text",
      name: "iosLink",
      formType: "input",
      label: "IOS Link",
      placeholder: "Enter IOS App Link",
      // validation: { required: "IOS App Link is required" },
    },
  ],
  appCardsMainContent: [
    {
      fieldName: "About Text (EN)",
      fieldValue: "about_text_english",
      className: "col-span-6",
      type: "text",
      name: "about_text_english",
      formType: "input",
      label: "About Text (EN)",
      placeholder: "Enter About text (EN)",
      validation: { required: "About text (EN) is required" },
    },
    {
      fieldName: "About Text (MS)",
      fieldValue: "about_text_malay",
      className: "col-span-6",
      type: "text",
      name: "about_text_malay",
      formType: "input",
      label: "About Text (MS)",
      placeholder: "Enter About text (MS)",
    },
    {
      fieldName: "About Text (ZH)",
      fieldValue: "about_text_mandarin",
      className: "col-span-6",
      type: "text",
      name: "about_text_mandarin",
      formType: "input",
      label: "About Text (ZH)",
      placeholder: "Enter About text (ZH)",
    },
    {
      fieldName: "About Description (EN)",
      fieldValue: "about_description_english",
      className: "col-span-6",
      type: "text",
      name: "about_description_english",
      formType: "textarea",
      label: "About Description (EN)",
      placeholder: "Enter About Description (EN)",
      validation: { required: "About Description (EN) is required" },
    },
    {
      fieldName: "About Description (MS)",
      fieldValue: "about_description_malay",
      className: "col-span-6",
      type: "text",
      name: "about_description_malay",
      formType: "textarea",
      label: "About Description (MS)",
      placeholder: "Enter About Description (MS)",
    },
    {
      fieldName: "About Description (ZH)",
      fieldValue: "about_description_mandarin",
      className: "col-span-6",
      type: "text",
      name: "about_description_mandarin",
      formType: "textarea",
      label: "About Description (ZH)",
      placeholder: "Enter About Description (ZH)",
    },
    {
      fieldName: "About Image",
      fieldValue: "aboutImage",
      className: "col-span-6",
      type: "image",
      name: "aboutImage",
      formType: "file",
      label: "About Image",
      placeholder: "Upload about image",
      usedFileType: "image/*",
      validation: { required: "About image is required" },
    },
  ],
  appCardsListContent: [
    {
      fieldName: "Card Name (EN)",
      fieldValue: "cardNameEn",
      className: "col-span-6",
      type: "text",
      name: "cardNameEn",
      formType: "input",
      label: "Card Name (EN)",
      placeholder: "Enter card Name (EN) ",
      validation: { required: "Card name (EN) is required" },
    },
    {
      fieldName: "Card Name (MS)",
      fieldValue: "cardNameMs",
      className: "col-span-6",
      type: "text",
      name: "cardNameMs",
      formType: "input",
      label: "Card Name (MS)",
      placeholder: "Enter Card Name (MS)",
    },
    {
      fieldName: "Card Name (ZH)",
      fieldValue: "cardNameZh",
      className: "col-span-6",
      type: "text",
      name: "cardNameZh",
      formType: "input",
      label: "Card Name (ZH)",
      placeholder: "Enter Card Name (ZH)",
    },
    {
      fieldName: "Card Description (EN)",
      fieldValue: "cardDescEn",
      className: "col-span-6",
      type: "text",
      name: "cardDescEn",
      formType: "textarea",
      label: "Card Description (EN)",
      placeholder: "Enter Card description (EN)",
      validation: {
        required: "Card description (EN) is required",
        validate: (value: string) => {
          const trimmed = value.trim();
          const wordCount = trimmed.split(/\s+/).filter(Boolean).length;
          if (wordCount > 20) {
            return `Card description must not exceed 20 words (currently ${wordCount}).`;
          }
          return true;
        },
      },
    },
    {
      fieldName: "Card Description (MS)",
      fieldValue: "cardDescMs",
      className: "col-span-6",
      type: "text",
      name: "cardDescMs",
      formType: "textarea",
      label: "Card Description (MS)",
      placeholder: "Enter Card Description (MS)",
      // validation: { required: "Card name (EN) is required" },
    },
    {
      fieldName: "Card Description (ZH)",
      fieldValue: "cardDescZh",
      className: "col-span-6",
      type: "text",
      name: "cardDescZh",
      formType: "textarea",
      label: "Card Description (ZH)",
      placeholder: "Enter Card description (ZH)",
      // validation: { required: "Card name (EN) is required" },
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Select if card is published",
    },
  ],
};

export default getMobileDrillDownData;
